import { http } from "../api/http";
import Utils from "../utils";

// Personal MCP tokens (#2719). Product Team issue, rotate and revoke them for anyone; the API refuses everyone else.
export const mcpUserTokenService = {
  list,
  findUsers,
  create,
  rotate,
  revoke,
};

/** Everyone's tokens, or one person's when a userId is given. */
function list(userId) {
  const query = userId ? `?${Utils.objectToQueryString({ userId })}` : "";
  return http.get(`/mcpusertoken${query}`);
}

function findUsers(search) {
  return http.get(`/mcpusertoken/users?${Utils.objectToQueryString({ search })}`);
}

function create(requestBody) {
  return http.post(`/mcpusertoken`, JSON.stringify(requestBody));
}

function rotate(tokenId, requestBody) {
  return http.post(`/mcpusertoken/${tokenId}/rotate`, JSON.stringify(requestBody));
}

function revoke(tokenId) {
  return http.delete(`/mcpusertoken/${tokenId}`);
}
